import { Router } from '@angular/router';
import { patchState, WritableStateSource } from '@ngrx/signals';
import { AuthState } from '../auth.state';

export const login = (
  store: WritableStateSource<AuthState>,
  router: Router,
) => {
  return () => {
    patchState(store, {loggedIn: true})
    router.navigate(['/']);
  }
};
